import styled from "styled-components/macro";

export const StyledSiteSettings = styled.div`
  form > div:last-child {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
`;
